/**
 *
 * @component 个人中心/我的方案/项目管理/项目详情/变更历史tab
 *
 **/
import React from 'react';
import './ChangeHistoryTab.scss';
const ChangeHistoryTab = props => {
    return (
        <div className="change-history">
            <section className="history-wrap">
                <header className="change-date">2021-04-26</header>
                <div className="change-content">
                    <div className="flag">最新版本</div>
                    <div className="change-time">13:48</div>
                    <div className="change-detail">
                        changshuhong 修改了{' '}
                        <span className="native-link">家具模型</span>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ChangeHistoryTab;
